import React, { useEffect } from 'react';
import HeroSection from '../components/home/HeroSection';
import FeaturedListings from '../components/home/FeaturedListings';
import NeighborhoodGuides from '../components/home/NeighborhoodGuides';
import QuickSearches from '../components/home/QuickSearches';
import LeadCaptureForm from '../components/forms/LeadCaptureForm';
import { ddfAPI } from '../services/api';

const HomePage = () => {
  // Preload search results in the background for faster search page load
  useEffect(() => {
    const preloadSearch = async () => {
      try {
        // Preload Brantford search (default) in the background
        const cacheKey = 'conti_search_cache';
        const existing = localStorage.getItem(cacheKey);
        if (!existing) {
          const data = await ddfAPI.getProperties({ keyword: 'Brantford', limit: 100 });
          if (data?.properties?.length > 0) {
            const validListings = data.properties.filter(p => p.price > 0);
            const filterKey = JSON.stringify({
              keyword: 'Brantford', minPrice: 'none', maxPrice: 'none',
              beds: 'any', baths: 'any', propertyType: 'all'
            });
            const cache = { [filterKey]: { data: validListings, timestamp: Date.now() } };
            localStorage.setItem(cacheKey, JSON.stringify(cache));
          }
        }
      } catch (e) {
        // Silent fail - this is just preloading
      }
    };
    // Delay preload to not block initial page render
    const timer = setTimeout(preloadSearch, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <HeroSection />
      <FeaturedListings />
      <NeighborhoodGuides />
      <QuickSearches />
      
      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Ready to Find Your <span className="text-red-600">Perfect Home?</span>
              </h2>
              <p className="text-gray-600 mb-6">
                Whether you're buying your first home, upgrading, or investing, Alexander Conti is here to guide you every step of the way. With deep local knowledge and a commitment to exceptional service, he'll help you make the right move.
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center gap-3">
                  <span className="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center text-white text-sm">✓</span>
                  Expert knowledge of local markets
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center text-white text-sm">✓</span>
                  Personalized service tailored to your needs
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center text-white text-sm">✓</span>
                  Access to exclusive listings
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center text-white text-sm">✓</span>
                  Proven track record of success
                </li>
              </ul>
            </div>
            <div>
              <LeadCaptureForm 
                variant="full" 
                title="Let's Connect" 
                subtitle="Tell me about your real estate goals"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
